<style lang="scss" scoped>
@use '~@/styles/components/btn';

.tiker {
  background-color: var(--color-chart);
}

.screener-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
}

.table-names {
  font-size: 12px;
  color: var(--color-text-dark);
  text-align: right;
  padding-right: 5px;
  vertical-align: center;
}

.table-value {
  font-size: 14px;
}

.tiker-table {
  margin: 0 auto;
  height: 25px;
  width: 100%;
  text-align: left;
  padding: 2px;
}

.volume-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.volume {
  white-space: nowrap;
}

.funding-positive {
  color: var(--color-success-light);
}

.funding-negative {
  color: var(--color-danger-light);
}

.funding-neutral {
  color: var(--color-text);
}
</style>
<style lang="scss">
.ivu-tooltip-inner-with-width { min-width: min(240px, calc(100vw - 16px)); }
</style>

<template>
  <div class="box1 tiker">
    <table class="tiker-table">
      <tr style="height: 26px">
        <td
          width="150px"
          class="table-names"
        >
          {{ $text.tr('ЦЕНА') }}
        </td>
        <td
          width="150px"
          class="table-value"
        >
          {{ lastPrice }}
        </td>
        <td
          width="150px"
          class="table-names"
        >
          {{ $text.tr('24Ч ИЗМЕНЕНИЕ') }}
        </td>
        <td
          width="150px"
          class="table-value"
          :class="{gred: symbolInfo && parseFloat(symbolInfo.Change24h) < 0, ggreen: symbolInfo && parseFloat(symbolInfo.Change24h) >= 0}"
        >
          {{ symbolInfo ? symbolInfo.Change24h : '' }}%
        </td>
        <td
          width="150px"
          class="table-names"
        >
          {{ $text.tr('24Ч ОБЪЕМ') }}
        </td>
        <td
          width="150px"
          class="table-value"
        >
          <div class="volume-wrapper">
            <span class="volume">{{ symbolInfo ? numberWithSpaces(symbolInfo.Volume24h) : '' }}</span>
            <span>{{ symbolInfo ? symbolInfo.quoteAsset : '' }}</span>
          </div>
        </td>
        <td
          v-if="showFundingRate"
          class="table-names"
          width="100px"
        >
          {{ $text.tr('СТАВКА') }}
        </td>
        <td
          v-if="showFundingRate"
          class="table-value"
          width="120px"
        >
          <Tooltip
            v-model="fundingTooltipVisible"
            placement="top"
            max-width="270"
            :delay="500"
            :content="fundingTooltip"
            transfer
          >
            <span :class="fundingColorClass" style="position:relative; z-index:1060" @click="fundingTooltipVisible = true">{{ fundingRateFormatted }}</span>
          </Tooltip>
          <div v-if="fundingTooltipVisible" class="funding-tooltip-dismiss-overlay" style="position:fixed; inset:0; z-index:1059" @click="fundingTooltipVisible = false"></div>
        </td>
        <td
          v-if="!$store.state.sys.tradeExchange.Demo"
          width="50px"
          class="table-value"
        >
          <div class="screener-btn-wrapper">
            <button
              class="ghost-btn ghost-btn_small"
              @click="openScreener()"
              :title="$text.tr('MultiChart')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="22px"
                width="22px"
                viewBox="0 0 24 24"
              >
                <g>
                  <path d="M19.88,18.47c0.44-0.7,0.7-1.51,0.7-2.39c0-2.49-2.01-4.5-4.5-4.5s-4.5,2.01-4.5,4.5s2.01,4.5,4.49,4.5 c0.88,0,1.7-0.26,2.39-0.7L21.58,23L23,21.58L19.88,18.47z M16.08,18.58c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5 s2.5,1.12,2.5,2.5C18.58,17.46,17.46,18.58,16.08,18.58z M15.72,10.08c-0.74,0.02-1.45,0.18-2.1,0.45l-0.55-0.83l-3.8,6.18 l-3.01-3.52l-3.63,5.81L1,17l5-8l3,3.5L13,6C13,6,15.72,10.08,15.72,10.08z M18.31,10.58c-0.64-0.28-1.33-0.45-2.05-0.49 c0,0,5.12-8.09,5.12-8.09L23,3.18L18.31,10.58z" />
                </g>
              </svg>
            </button>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Decimal from 'decimal.js'
import fundingRateService from '@/services/fundingRate'

export default {
  name: 'SymbolTicker',
  props: ['mode'],
  data () {
    return {
      fundingRate: null,
      fundingTooltipVisible: false
    }
  },
  computed: {
    symbolsFilter () {
      return this.$store.state.data.symbolsfilter
    },
    symbolInfo () {
      if (this.mode === 'grids') {
        return this.symbolsFilter[this.$store.state.grids.symbol]
      } else if (this.mode === 'bots') {
        return this.symbolsFilter[this.$store.state.bots.symbol]
      } else {
        return this.symbolsFilter[this.$store.state.trade.symbol]
      }
    },
    currentSymbol () {
      if (this.mode === 'grids') {
        return this.$store.state.grids.symbol
      } else if (this.mode === 'bots') {
        return this.$store.state.bots.symbol
      } else {
        return this.$store.state.trade.symbol
      }
    },
    exchId () {
      return this.$store.state.sys.tradeExchange.ExchId
    },
    hasFundingRate () {
      const eid = this.exchId
      return eid === 'BYF' || eid === 'GEF' || eid === 'BIF' || this.$store.getters.isOKXFutures
    },
    showFundingRate () {
      return this.hasFundingRate && this.fundingRate !== null
    },
    fundingRateFormatted () {
      if (this.fundingRate === null || this.fundingRate === undefined) return '—'
      return new Decimal(this.fundingRate).toFixed(4, Decimal.ROUND_UP) + '%'
    },
    fundingColorClass () {
      if (this.fundingRate === null || this.fundingRate === undefined) return ''
      const rate = new Decimal(this.fundingRate)
      if (rate.isZero()) return 'funding-neutral'
      return rate.gt(0) ? 'funding-positive' : 'funding-negative'
    },
    fundingTooltip () {
      return this.$text.tr('Положительная ставка финансирования: трейдеры с лонг-позициями платят трейдерам с шорт-позициями.\nОтрицательная ставка финансирования: трейдеры с шорт-позициями платят трейдерам с лонг-позициями.\nКомиссия за финансирование = стоимость позиции × ставка финансирования.')
    },
    lastPrice () {
      if (this.mode === 'grids') {
        return this.$store.state.grids.lastPrice
      } else if (this.mode === 'bots') {
        return this.$store.state.bots.lastPrice
      } else {
        return this.$store.state.sys.lastPrice
      }
    }
  },
  watch: {
    currentSymbol () {
      this.fetchFundingRate()
    },
    exchId () {
      this.fetchFundingRate()
    }
  },
  mounted () {
    this.fetchFundingRate()
  },
  methods: {
    async fetchFundingRate () {
      if (!this.hasFundingRate || !this.currentSymbol) {
        this.fundingRate = null
        return
      }
      this.fundingRate = await fundingRateService.FetchFundingRate(this.exchId, this.currentSymbol)
    },
    openScreener () {
      window.open(`${window.location.origin}/app/multichart`, 'screener')
    },
    numberWithSpaces (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
}
</script>
